export const PEP_FLAG = { 'PEP': 1, 'Related to PEP': 2, 'Not Applicable': 3 };
export const PEP_FLAG_ARRAY = ['', 'PEP', 'Related to PEP', 'Not Applicable'];